import React, { useState } from 'react';
import AuthenticatedComponent from '../../AuthenticatedComponent';
import DatePicker from 'react-date-picker';
import { parseISO } from 'date-fns';
import WaitingListService from '../../../services/WaitingListService';
import PersonService from '../../../services/PersonService';

function EditWaitingListEntryComponent(props) {
    const [waitingListEntry, setWaitingListEntry] = useState(props.waitingListEntry);
    const [referer, setReferer] = useState(props.referer);

    const save = () => {
        if (props.isWaitingList) {
            if (waitingListEntry.referer_id && waitingListEntry.waiting_list_type_id === 2) {
                PersonService.update(referer);
                props.updateReferer(referer);
                WaitingListService.updateWaitinglistEntry(waitingListEntry);
            } else {
                WaitingListService.updateWaitinglistEntry(waitingListEntry);
            }
        } else {
            if (waitingListEntry.referer_id && waitingListEntry.waiting_list_type_id === 2) {
                PersonService.update(referer);
                props.updateReferer(referer);
                WaitingListService.updateApplication(waitingListEntry);
            } else {
                WaitingListService.updateApplication(waitingListEntry);
            }
        }

        props.redigerClick();
    };

    return (
        <td colSpan="6">
            <div className="panel panel-default">
                <div className="panel-body textAlignLeft" >
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Fornavn</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.firstname} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, firstname: event.target.value } })} type="text" />
                            </div>
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Efternavn</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.lastname} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, lastname: event.target.value } })} type="text" />
                            </div>

                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Address</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.address} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, address: event.target.value } })} type="text" />
                            </div>
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>By</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.suburb} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, suburb: event.target.value } })} type="text" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Postnummer</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.postcode} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, postcode: event.target.value } })} type="text" />
                            </div>
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>E-mail</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.email} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, email: event.target.value } })} type="text" />
                            </div>
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Telefon</label>
                                </div>
                                <input className="form-control" name="type" value={waitingListEntry.person.phone} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, person: { ...waitingListEntry.person, phone: event.target.value } })} type="text" />
                            </div>
                            <div className="col-md-3 panelRowPadding ">
                                <div>
                                    <label>Dato for indskrivelse</label>
                                </div>
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    value={parseISO(waitingListEntry.entry_date)}
                                    onChange={date => setWaitingListEntry({ ...waitingListEntry, entry_date: date.toISOString() })}
                                    className="form-control"
                                />
                            </div>
                        </div>
                        {props.waitingListEntry.waiting_list_type_id === 2 &&
                            <div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Fornavn</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.firstname} onChange={(event) => setReferer({ ...referer, firstname: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Efternavn</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.lastname} onChange={(event) => setReferer({ ...referer, lastname: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Address</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.address} onChange={(event) => setReferer({ ...referer, address: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere By</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.suburb} onChange={(event) => setReferer({ ...referer, suburb: event.target.value })} type="text" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Postnummer</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.postcode} onChange={(event) => setReferer({ ...referer, postcode: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Email</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.email} onChange={(event) => setReferer({ ...referer, email: event.target.value })} type="text" />
                                    </div>
                                    <div className="col-md-3 panelRowPadding ">
                                        <div>
                                            <label>Referere Telefon</label>
                                        </div>
                                        <input className="form-control" name="type" value={referer.phone} onChange={(event) => setReferer({ ...referer, phone: event.target.value })} type="text" />
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-md-6 panelRowPadding ">
                                <div>
                                    <label>Noter</label>
                                </div>
                                <textarea className="form-control" rows="2" id="comment" value={waitingListEntry.note} onChange={(event) => setWaitingListEntry({ ...waitingListEntry, note: event.target.value })} ></textarea>
                            </div>
                        </div>
                    </div>
                        <div className="col-md-12">
                            <div className="col-md-offset-6  col-md-3 panelRowPadding">
                                <button className="btn btn-primary" onClick={props.redigerClick}>Afbryd</button>
                            </div>
                            <div className="col-md-3 panelRowPadding">
                                <button className="btn btn-primary" onClick={save}>Gem</button>
                            </div>
                        </div>
                    </div>
                </div>
        </td>
    );
}

export default AuthenticatedComponent(EditWaitingListEntryComponent);